import React, { Fragment } from 'react';
import { Container, Button } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ReceitasEduc from '../../../components/educacao/receitas';


function ReceitasEducScreen() {
    return (
        <Fragment>
            <Head titulo="Arrecadação da Secretaria de Educação em Macuco" />
            <Header />
            <Container>
               <ReceitasEduc /><br/><br/>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ReceitasEducScreen;